import { render, staticRenderFns } from "./AuthHeader.vue?vue&type=template&id=15f74fec&scoped=true"
import script from "./AuthHeader.vue?vue&type=script&lang=js"
export * from "./AuthHeader.vue?vue&type=script&lang=js"
import style0 from "./AuthHeader.vue?vue&type=style&index=0&id=15f74fec&prod&scoped=true&lang=css"
import style1 from "./AuthHeader.vue?vue&type=style&index=1&id=15f74fec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f74fec",
  null
  
)

export default component.exports